export default "0d2ec71c43ff1ada.png"